<template>
    <div
        v-animation:bottom.delay
        v-if="pagination.pageCount > pagination.currentPage"
        class="t-load-more"
    >
        <div
            class="t-btn _border-green _big"
            :class="{_disabled: disabledBtn}"
            @click="clickLoadMore(pagination.currentPage)"
        >
            {{ btn }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "load-more",
        props: {
            pagination: Object,
            btn: String,
            blogId: {
                type: String,
                default: undefined
            },
            formName: {
                type: String,
                default: undefined
            },
            disabledBtn: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            clickLoadMore(currentPage) {
                this.$emit('set-current-form-name', this.formName);
                this.$router.push({
                    name: this.$route.name,
                    query: Object.assign(
                        {},
                        this.$route.query,
                        {
                            [this.formName ? `${this.formName}[loadMore]` : 'loadMore']: true,
                            [this.formName ? `${this.formName}[currentPage]` : 'currentPage']: 1 + parseInt(currentPage),
                            blogId: this.blogId
                        }
                    )}).catch(err => {});
            }
        },
        created() {
            if (this.formName ? this.$route.query[`${this.formName}[loadMore]`] : this.$route.query.loadMore) {
                this.$router.push({
                    name: this.$route.name,
                    query: Object.assign(
                        {},
                        this.$route.query,
                        {
                            [this.formName ? `${this.formName}[loadMore]` : 'loadMore']: undefined,
                            [this.formName ? `${this.formName}[currentPage]` : 'currentPage']: undefined,
                            blogId: this.blogId
                        }
                    )}).catch(err => {});
            }
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/ui-components/load-more/load-more.vue